<template>
  <div class="container-xxl py-24">
    <MetaTags
      :title="`Работа в ${company.name}: Вакансии и карьера`"
      :description="`Ищете работу в ${company.name}? Посмотрите актуальные вакансии и присоединяйтесь к нам для увлекательной карьеры!`"
    />
    <AppBreadcrumbs
      :links="[
        {
          text: 'Компании',
          alias: `/companies/`
        },
        {
          text: `${company.name}`
        }
      ]"
    />
    <div class="d-flex flex-md-row flex-column row align-items-md-start align-items-center">
      <h1 class="fw-bold d-md-none d-block mb-24">
        Компания <span class="text-primary d-sm-inline-block d-block">{{ company.name }}</span>
      </h1>
      <div class="col-12 col-md-3 d-flex mb-24 col-custom-1 justify-content-md-start justify-content-center">
        <div class="d-flex flex-column align-items-center">
          <div class="col-12 img-logo">
            <img
              :src="company.logo"
              :alt="company.name"
              class="w-100 h-100 rounded-20"
              style="object-fit: contain"
            >
          </div>
          <AppButton
            class="mt-15"
            rel="nofollow"
            :variant="BtnVariant.Link"
            :href="company.site"
          >
            {{ company.site }}
          </AppButton>
        </div>
      </div>
      <div class="col-12 col-md-9 col-custom-2">
        <h1 class="fw-bold company-title-right d-md-block d-none">
          Компания <span class="text-primary">{{ company.name }}</span>
        </h1>
        <div class="mb-10 text-break">
          {{ company.description }}
        </div>
      </div>
    </div>
    <div class="row mt-24">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center py-12 flex-md-row flex-column">
          <div class="d-flex flex-md-row flex-column align-items-center mb-md-0 mb-43">
            <h2 class="d-inline fw-bold me-10">
              Вакансии
            </h2>
            <searchCounter
              :count="itemsCount"
              :page="page"
              :per-page="perPage"
            />
          </div>
          <div class="d-flex gap-24 d-none">
            <button class="btn d-flex align-items-center fw-medium text-dark py-12 px-25 border border-1 border-platinum rounded-pill shadow-none">
              Сначала новые
              <svg
                width="20"
                height="11"
                viewBox="0 0 20 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                data-inject-url="https://peterdraw.studio/ziro-html/assets/icons/chevron-down.svg"
                class="svg-inject text-primary is-20 ms-15"
              >
                <path d="M19.6273 1.77879L10.6273 9.77878C10.4448 9.9391 10.2102 10.0275 9.96728 10.0275C9.72437 10.0275 9.48977 9.9391 9.30728 9.77878L0.307278 1.77879C0.121445 1.6003 0.0116842 1.35696 0.000880246 1.09952C-0.00992376 0.842077 0.0790634 0.5904 0.249287 0.396964C0.419511 0.203528 0.657833 0.0832638 0.91456 0.0612484C1.17129 0.039233 1.42661 0.117165 1.62728 0.278796L9.96728 7.68878L18.3073 0.278796C18.4046 0.185284 18.5199 0.112452 18.6462 0.0646883C18.7724 0.0169249 18.9071 -0.00478066 19.0419 0.000879482C19.1768 0.00653962 19.3091 0.0394483 19.4309 0.0976224C19.5528 0.155797 19.6615 0.238031 19.7507 0.339371C19.8399 0.440711 19.9076 0.559058 19.9498 0.687279C19.9921 0.8155 20.0079 0.950941 19.9963 1.08544C19.9848 1.21994 19.9462 1.35071 19.8827 1.46987C19.8193 1.58903 19.7324 1.69412 19.6273 1.77879Z" />
              </svg>
            </button>
          </div>
        </div>
        <AppLoader
          :is-hide="!loading"
          class="w-100"
        />
        <div v-show="!loading">
          <SearchItem
            v-for="(item, index) in vacancies.items"
            :key="item.id"
            :id="item.id"
            :is-vacancy="source !== 2"
            :img="undefined"
            :title="item.profession.title"
            :subtitle="item.company.name"
            :salary="item.salary"
            :time="new Date((source === 2 ? item.updated : item.publicationDate) * 1000)"
            :experience="getExperience(item)"
            :is-active="activeVacancy === index"
            :hide-favorite="false"
            :is-favorite="item.favorite !== null && client.isAuthenticated"
            @click="router.push(`/vacancies/${item.id}`)"
            @favorite="favoriteControl(index)"
            @open-click="openVacancy(item.id)"
          />
        </div>
        <PaginationComponent
          :per-page="perPage"
          :items-count="itemsCount"
          @change-page="getVacancies"
        />
        <div
          v-if="companies.count > 0"
          class="d-flex flex-column container-xxl py-60"
        >
          <h2 class="heading-section-2 text-dark text-center mb-0">
            Последние компании
          </h2>
          <div class="profile-card-slider position-relative">
            <Swiper
              class="candidate-carousel swiper swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden"
              :modules="[ SwiperNavigation ]"
              :navigation="{ nextEl: '.candidate-carousel-next', prevEl: '.candidate-carousel-prev', disabledClass: 'disabled' }"
              :slides-per-view="1"
              :breakpoints="{ 768: { slidesPerView: 2}, 1200: { slidesPerView: 3 }, 1400: { slidesPerView: 4 } }"
            >
              <SwiperSlide
                v-for="item in companies.items"
                class="swiper-slide swiper-slide-duplicate"
              >
                <CompanySearchItem
                  :id="item.id"
                  :title="item.name"
                  :img="item.logo"
                  :time="new Date(item.created * 1000)"
                  :count-vacancy="item.countVacancy"
                  :type-company="item.type === 1 ? 'Работодатель' : 'Агенство'"
                  :is-slider="true"
                />
              </SwiperSlide>
            </Swiper>
            <div
              class="candidate-carousel-prev profile-card-button-prev btn"
              tabindex="0"
              role="button"
              aria-label="Previous slide"
            >
              <svg
                class="svg-inject svg-icon"
                style="rotate: 180deg"
              >
                <use xlink:href="/public/icons/main.svg#east" />
              </svg>
            </div>
            <div
              class="candidate-carousel-next profile-card-button-next btn"
              tabindex="0"
              role="button"
              aria-label="Next slide"
            >
              <svg class="svg-inject svg-icon">
                <use xlink:href="/public/icons/main.svg#east" />
              </svg>
            </div>
          </div>
          <NuxtLink
            class="d-none btn btn-primary btn-rounded mx-auto fw-bold"
            to="#"
          >
            Все компании
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Company } from "~/entities/company";
import type {Vacancy} from "~/entities/vacancy";
import {useClient} from "~/stores/client";
import CompanySearchItem from "~/components/CompanySearch/CompanySearchItem.vue";
import { useApiFavorite } from "~/composables/api/favorite";
import {BtnVariant} from "~/composables/enums/BtnVariant";
import {getAlias} from "~/composables/utils/SearchItemAlias";
import {SearchSource} from "~/composables/enums/SearchSource";

const route = useRoute();
const router = useRouter();
const client = useClient();
const apiFavorite = useApiFavorite(client.getClientId);

//-----TYPES-----\\
type CompaniesResponse = {
  items: [];
  count: number
};
type VacancySearch = Vacancy & { company: Company; response: { id: string }|null };
type VacanciesResponse = {
  items: VacancySearch[];
  count: number
};

//-----VARIABLES-----\\
const perPage = 10;
const experience = [
  {
    id: 0,
    title: 'Нет опыта',
  },
  {
    id: 1,
    title: 'От 1 года до 3 лет',
  },
  {
    id: 2,
    title: 'От 3 до 6 лет',
  },
  {
    id: 3,
    title: 'Более 6 лет',
  },
];

//-----STATE-----\\
const company = ref<Company|null>(null);
const companies = ref<CompaniesResponse>({ items: [], count: 0 });
const page = ref<number>(route.query.page??1);
const itemsCount = ref<number>(0);
const vacancies = ref<VacanciesResponse>({ items: [], count: 0 });
const loading = ref<boolean>(false);

//----ASYNC----\\
const { data } = await mainFetch(`/companies/${route.params.id}`);
company.value = data.value.company;

const companiesData = await mainFetch('companies', {
  query: {
    companyMain: company.value.id,
    perPage: 10
  }
});
companies.value = companiesData.data.value.companies;

await getVacancies();

//-----COMPUTED-----\\

//-----METHODS-----\\
async function getVacancies(newPage: number|null = null) {
  loading.value = true;
  if (newPage !== null) {
    page.value = newPage;
  }

  const { data } = await mainFetch('vacancies', {
    query: {
      perPage,
      type: 'search',
      companyId: route.params.id,
      page: newPage??route.query.page
    }
  });
  vacancies.value = data.value.vacancies;
  itemsCount.value = data.value.vacancies.count;
  loading.value = false;
}
async function favoriteControl(index: number) {
  if (!client.isAuthenticated) {
    //TODO: предлагать аторизоваться
    return;
  }

  vacancies.value.items[index].favorite;
  if (vacancies.value.items[index].favorite === null) {
    const id: string|null = await apiFavorite.add(vacancies.value.items[index].id as string, 1);
    if (id !== null) {
      vacancies.value.items[index].favorite = { id };
    }
    return;
  }

  const isAdded: boolean = await apiFavorite.delete(vacancies.value.items[index].favorite.id);
  if (isAdded) {
    vacancies.value.items[index].favorite = null;
  }
}
function getExperience(item: Object) {
  return experience?.find((element) => {
    return element.id === item.experience ? element : null;
  })?.title;
}
function openVacancy(id: string) {
  router.push(getAlias(SearchSource.Vacancies, id));
}
</script>

<style scoped lang="scss">
  .img-logo {
    background-size: cover;
    background-position: 50%;
    height: 220px;
    width: 220px;

    @media (max-width: 767px) {
      width: 200px;
      height: 200px;
    }
  }
  .col-custom-1 {
    @media (min-width: 1400px) {
      width: 20%;
    }
    @media (max-width: 870px) {
      width: 35%;
    }
    @media (max-width: 767px) {
      width: 100%;
    }
  }
  .col-custom-2 {
    @media (max-width: 870px) {
      width: 65%;
    }
    @media (max-width: 767px) {
      width: 100%;
    }
  }
</style>